import { Injectable } from '@nestjs/common';
import {VariantDTO} from './dto/item-variant.dto';
import {Variant} from './item-variant.entity';
import {VariantAdapter} from './dto/item-variant.adapter';
import {VariantResponseModel, AllVariantResponseModel,VariantStatusWiseResponseModel,VariantDto, VariantsDropDownDto} from '@gtpl/shared-models/masters';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { VariantRequest } from './dto/item-variant-request';


@Injectable()
export class VariantService {

  constructor(
    @InjectRepository(Variant)
    private variantRepository: Repository<Variant>,
    private variantAdapter: VariantAdapter,
  ){}
  
    async getVariantWithoutRelations(variantId: number): Promise<Variant>{
      const VariantResponse = await this.variantRepository.findOne({
        where: {variantId: Raw(alias => `variant_id = '${variantId}'`)},
      });
      if(VariantResponse){
        return VariantResponse;
      }
      else{
        return null;
      }
    }

    async createVariant(variantDto: VariantDTO, isUpdate: boolean): Promise<VariantResponseModel>{

      try{
        if(!isUpdate){
          const VariantEntity = await this.getVariantWithoutRelations(variantDto.variantId);
          if (VariantEntity){
            throw new ErrorResponse(11104, 'Item-Variant already exists'); 
          }
        }
        const convertedVariantEntity: Variant = this.variantAdapter.convertDtoToEntity(variantDto,isUpdate);
      const savedVariantEntity: Variant = await this.variantRepository.save(
        convertedVariantEntity
      );
      const savedVariantDto: VariantDTO = this.variantAdapter.convertEntityToDto(savedVariantEntity);
        // console.log(savedStateDto);
      if (savedVariantDto) {
        // generating resposnse
      const response = new VariantResponseModel(true,1,isUpdate? 'Item-Variant Updated Successfully': 'Item-Variant Created Successfully',savedVariantDto);
      return response;
       
      } else {
        //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
        throw new ErrorResponse(11106,'Item-Variant saved but issue while transforming into DTO');
      }
    } catch (error) {
      // when error occures while saving the data , the execution will come to catch block.
      // tslint:disable-next-line: typedef
      throw error;
    }
  }
  async getAllVariants(): Promise<AllVariantResponseModel> {
    // const page: number = 1;
    try {
      const variantDto: VariantDTO[] = [];
      //retrieves all companies
      const variantEntities: Variant[] = await this.variantRepository.find({order :{variantName:'ASC'}});
      //console.log(statesEntities);
      if (variantEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        variantEntities.forEach(VariantEntity => {
          const convertedvariantDto: VariantDTO = this.variantAdapter.convertEntityToDto(
            VariantEntity
          );
          variantDto.push(convertedvariantDto);
        });

        //generated response
    const response = new AllVariantResponseModel(true,1,'Item-Varient retrieved successfully',variantDto);
    return response;

       
      } else {
        throw new ErrorResponse(99998, 'Data not found');
      }
    } catch (err) {
      throw err;
    }
  }
  async updateVariantStatus(variantsDto:VariantDto):Promise<AllVariantResponseModel>{
     try{
        await this.variantRepository.update(variantsDto.variantId,variantsDto);
        const variantDtos:VariantDTO[] = [];
        //retrieves all companies
       //  await this.statesRepository.save();
        const variantEntities: Variant[] = await this.variantRepository.find({
          where: { status: 1 },
          order: { variantName: 'DESC' }
        });
        if (variantEntities) {
          // converts the data fetched from the database which of type companies array to type StateDto array.
          variantEntities.forEach(variantEntity => {
            const convertedvariantsDto: VariantDTO = this.variantAdapter.convertEntityToDto(variantEntity);
            variantDtos.push(convertedvariantsDto);
          });
          //generated response
    const response = new AllVariantResponseModel(true,1,'Item-variant updated successfully',variantDtos);
    return response;
        } else {
          throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
        }
        const chat_ids=[36475226];
       // this.botService.botMessage(chat_ids,'State updated');
        
     }catch (error) {
       // tslint:disable-next-line: typedef
       throw error;
     }
 
   }
   async getAllActiveVariants(): Promise<AllVariantResponseModel> {
    const page: number = 1;
    try {
      // const statesDtos: StatesDTO[] = [];
      const variantDtos:VariantDTO[] = [];
      //retrieves all companies
      const variantEntities: Variant[] = await this.variantRepository.find({
        where: { isActive: 1 },
        order: { createdAt: 'DESC' }
      });
      if (variantEntities) {
        // converts the data fetched from the database which of type companies array to type StateDto array.
        variantEntities.forEach(variantEntity => {
          const convertedvariantDto: VariantDTO = this.variantAdapter.convertEntityToDto(variantEntity);
          variantDtos.push(convertedvariantDto);
        });
        //generated response
    const response = new AllVariantResponseModel(true,1,'Variants retrieved successfully',variantDtos);
    return response;

      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
    } catch (err) {
      throw err;
    }
  }
  async getActiveVariantsCount(): Promise<VariantStatusWiseResponseModel> {
    const page: number = 1;
    try {
      //retrieves all companies
      const variantStatusWiseCount = await getConnection()
      .createQueryBuilder()
      .select("Sum(IF(is_active = true, 1, 0)) as activeCount,Sum(IF(is_active = false, 1, 0)) as inActiveCount, count(*) as cnt")
      .from(Variant, "Variant")
      .orderBy('is_active','ASC')
      .getRawOne();
      // console.log('Active States'+statesStatusWiseCount.activeCount);
      if (variantStatusWiseCount) {
    const response = new VariantStatusWiseResponseModel(true,1,'States retrieved successfully',variantStatusWiseCount.activeCount,variantStatusWiseCount.inActiveCount,variantStatusWiseCount.cnt);
    return response;      
      } else {
        throw new ErrorResponse(99998, 'enPmsLabels.errorCodes[99998]');
      }
    } catch (err) {
      throw err;
    }
  }

  async getVarientDataById(varReq: VariantRequest): Promise<VariantsDropDownDto> {
    const ItemEntities = await this.variantRepository.findOne({select: ['variantId', 'variantName'],
      where:{variantId:varReq.variantId}
      });
      if(ItemEntities){
      const response = new VariantsDropDownDto(ItemEntities.variantId,ItemEntities.variantName);
    return response;
      }else{
          throw new ErrorResponse(11106,'Something went wrong');
      }

}


}

